// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ReconcileImpactedCommitments_CommitmentLikeFragmentDoc } from './ReconcileImpactedCommitmentsStep.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PurchaseOrderCleanupChangeEventQueryVariables = Types.Exact<{
  changeEventId: Types.Scalars['ID']['input'];
}>;


export type PurchaseOrderCleanupChangeEventQuery = { __typename?: 'Query', changeEvent: { __typename?: 'ChangeEvent', id: string, project:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
    , impactedCommitments: Array<
      | { __typename?: 'Commitment', shortName: string, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }
      | { __typename?: 'CommitmentChangeOrder', shortName: string, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }
    >, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number } }>, materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, originalProjectItem: { __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number, planBasedCostHoldingProjectItems: Array<{ __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number }> } }> } };

export type PurchaseOrderCleanup_ChangeEventFragment = { __typename?: 'ChangeEvent', id: string, project:
    | { __typename?: 'StandaloneProject', id: string }
    | { __typename?: 'Region', id: string }
    | { __typename?: 'Market', id: string }
    | { __typename?: 'Community', id: string }
    | { __typename?: 'Subdivision', id: string }
    | { __typename?: 'Lot', id: string }
    | { __typename?: 'Structure', id: string }
    | { __typename?: 'Unit', id: string }
  , impactedCommitments: Array<
    | { __typename?: 'Commitment', shortName: string, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }
    | { __typename?: 'CommitmentChangeOrder', shortName: string, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }
  >, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number } }>, materialVariantSwaps: Array<{ __typename?: 'ChangeEventMaterialVariantSwap', id: string, originalProjectItem: { __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number, planBasedCostHoldingProjectItems: Array<{ __typename?: 'ProjectItem', id: string, allCommittedCostInCents: number }> } }> };

export type PurchaseOrderCleanup_CommitmentLike_Commitment_Fragment = { __typename?: 'Commitment', shortName: string, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> };

export type PurchaseOrderCleanup_CommitmentLike_CommitmentChangeOrder_Fragment = { __typename?: 'CommitmentChangeOrder', shortName: string, id: string, pendingBilledInCents?: number | null | undefined, status: Types.CommitmentStatus, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> };

export type PurchaseOrderCleanup_CommitmentLikeFragment =
  | PurchaseOrderCleanup_CommitmentLike_Commitment_Fragment
  | PurchaseOrderCleanup_CommitmentLike_CommitmentChangeOrder_Fragment
;

export const PurchaseOrderCleanup_CommitmentLikeFragmentDoc = gql`
    fragment PurchaseOrderCleanup_CommitmentLike on CommitmentLike {
  ...ReconcileImpactedCommitments_CommitmentLike
  shortName
  lineItems {
    id
    projectItem {
      id
    }
  }
}
    ${ReconcileImpactedCommitments_CommitmentLikeFragmentDoc}`;
export const PurchaseOrderCleanup_ChangeEventFragmentDoc = gql`
    fragment PurchaseOrderCleanup_ChangeEvent on ChangeEvent {
  id
  project {
    id
  }
  impactedCommitments(excludePrecon: true) {
    ...PurchaseOrderCleanup_CommitmentLike
  }
  lineItems {
    id
    projectItem {
      id
      allCommittedCostInCents
    }
  }
  materialVariantSwaps {
    id
    originalProjectItem {
      id
      allCommittedCostInCents
      planBasedCostHoldingProjectItems {
        id
        allCommittedCostInCents
      }
    }
  }
}
    ${PurchaseOrderCleanup_CommitmentLikeFragmentDoc}`;
export const PurchaseOrderCleanupChangeEventDocument = gql`
    query PurchaseOrderCleanupChangeEvent($changeEventId: ID!) {
  changeEvent(id: $changeEventId) {
    ...PurchaseOrderCleanup_ChangeEvent
  }
}
    ${PurchaseOrderCleanup_ChangeEventFragmentDoc}`;

/**
 * __usePurchaseOrderCleanupChangeEventQuery__
 *
 * To run a query within a React component, call `usePurchaseOrderCleanupChangeEventQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchaseOrderCleanupChangeEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchaseOrderCleanupChangeEventQuery({
 *   variables: {
 *      changeEventId: // value for 'changeEventId'
 *   },
 * });
 */
export function usePurchaseOrderCleanupChangeEventQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables> & ({ variables: PurchaseOrderCleanupChangeEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>(PurchaseOrderCleanupChangeEventDocument, options);
      }
export function usePurchaseOrderCleanupChangeEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>(PurchaseOrderCleanupChangeEventDocument, options);
        }
// @ts-ignore
export function usePurchaseOrderCleanupChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>;
export function usePurchaseOrderCleanupChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PurchaseOrderCleanupChangeEventQuery | undefined, PurchaseOrderCleanupChangeEventQueryVariables>;
export function usePurchaseOrderCleanupChangeEventSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>(PurchaseOrderCleanupChangeEventDocument, options);
        }
export type PurchaseOrderCleanupChangeEventQueryHookResult = ReturnType<typeof usePurchaseOrderCleanupChangeEventQuery>;
export type PurchaseOrderCleanupChangeEventLazyQueryHookResult = ReturnType<typeof usePurchaseOrderCleanupChangeEventLazyQuery>;
export type PurchaseOrderCleanupChangeEventSuspenseQueryHookResult = ReturnType<typeof usePurchaseOrderCleanupChangeEventSuspenseQuery>;
export type PurchaseOrderCleanupChangeEventQueryResult = ApolloReactCommon.QueryResult<PurchaseOrderCleanupChangeEventQuery, PurchaseOrderCleanupChangeEventQueryVariables>;